import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user, checking } = useAuth();
    const location = useLocation();

    if (checking || user === null) {
        return (
            <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-checking">
                <Loader2 className="w-6 h-6 animate-spin text-blue-700" />
            </div>
        );
    }
    if (!user) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }
    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/" replace />;
    }
    return children;
}
